import "@/App.css";
import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import PortalAbogado from "@/pages/PortalAbogado";
import Dashboard from "@/pages/Dashboard";
import GranosApp from "@/granos/GranosApp";
import { Toaster } from "@/components/ui/sonner";
import AssistantWidget from "@/components/AssistantWidget";
import PortalApp from "@/portal/PortalApp";
import { esHostPortal, esPortal } from "@/lib/portal";

function App() {
  // En móvil los toasts van abajo para no tapar el botón de menú (hamburguesa) arriba.
  const [isDesktop, setIsDesktop] = useState(() => typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches);
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const onChange = (e) => setIsDesktop(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          {esHostPortal() ? <Routes><Route path="/*" element={<PortalApp />} /></Routes> : <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/abogado/:token" element={<PortalAbogado />} />
            <Route path="/granos" element={<GranosApp />} />
            <Route path="/portal/*" element={<PortalApp />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
          </Routes>}
          {!esPortal() && <AssistantWidget />}
        </BrowserRouter>
        <Toaster position={isDesktop ? "top-right" : "bottom-center"} richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
